<div class="wrapper">
  <app-generate-voucher></app-generate-voucher>
</div>
<div class="wrapper">
  <app-validate-voucher></app-validate-voucher>
</div>
<div class="wrapper">
  <app-simulate-booking></app-simulate-booking>
</div>
